module.exports = __webpack_public_path__ + "img/down.a9838d60.png";